// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__34jkq","right":"styles_right__nwNgh"};